// extracted by mini-css-extract-plugin
export default {"ant-tabs-tabpane":"styles_ant-tabs-tabpane__z-vdW","ant-tabs-tabpane-active":"styles_ant-tabs-tabpane-active__uIBfT","Con":"styles_Con__EQrgv"};